import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import AddEditFaq from "../pages/cms/FaqManagement/AddEditFaq";
import FaqList from "../pages/cms/FaqManagement/List";
import AddEditEmailTemplate from "../pages/EmailTemplate/AddEditEmailTemplate";
import EmailTemplateList from "../pages/EmailTemplate/List";
import ViewEmailDetail from "../pages/EmailTemplate/ViewEmail";
import GlobalSetting from "../pages/Global Setting";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import AboutUsPage from "../pages/cms/AboutUs";
import ModelManagementList from "../pages/ModelManagement/List";
import EditModel from "../pages/ModelManagement/EditModel";
import ModelCommission from "../pages/ModelManagement/ModelCommission";
import ViewModel from "../pages/ModelManagement/ViewModel";

const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));
const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = <div>Loading...</div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = () => {
  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        {
          path: "user-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewUserManagement />),
            },
          ],
        },

        {
          path: "performer-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ModelManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <EditModel />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditModel />),
            },

            {
              path: "model-commission/:id",
              element: makeLazyComponent(() => <ModelCommission />),
            },

            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewModel />),
            },
          ],
        },

        {
          path: "email-template",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <EmailTemplateList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditEmailTemplate />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditEmailTemplate />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewEmailDetail/>),
            },
          ],
        },

        {
          path: "cms",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CmsPage />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCms />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCms />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCms />),
            },
            
          ],
        },        
        {
          path: "about-us",
          children: [
            { index: true, element: <AboutUsPage /> },
          ]
        },

        {
          path: "faq",
          children: [
            { index: true, element: makeLazyComponent(() => <FaqList />) },
            { path: "add", element: makeLazyComponent(() => <AddEditFaq />) },
            { path: "edit/:id", element: makeLazyComponent(() => <AddEditFaq />) },
            // { path: "view/:id", element: makeLazyComponent(() => <ViewCourceManagement />), },
          ]
        },
      ],
    },
    { path: "*", element: <Navigate to="/dashboard" /> },
  ];

  return useRoutes(routes);
};

export default MainRouting;